import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import { Button, createTheme, useTheme } from "@mui/material";
import { Navigation, Session } from "@toolpad/core";
import { AppProvider } from "@toolpad/core/react-router-dom";
import axios from "axios";
import * as React from "react";
import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Outlet, Route, Routes, useNavigate } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import "./app.scss";
import AppRoutes from "./app/components/app-routes";
import CredentialsSignInPage from "./app/pages/sign-in";
import { environment } from "./environments/environment";
import { setupAxios } from "./interceptor";
import {
  RootState,
  ServerErrorState,
  authActions,
  fetchLogout,
  fetchRefreshToken,
  getReduxStore,
  loadingActions,
  serverErrorActions,
  useAppDispatch,
} from "./redux";
import Layout from "./ui/layout/dashboard";
import { MenuItemModel } from "./ui/models/menuItemModel";
import { UserInfo } from "./ui/models/userInfo";

const setupAxiosAsync = async (setAxiosConfigured: any) => {
  // Interceptor Setup
  const settings = await environment;
  setupAxios(
    axios,
    settings.apiUrl,
    getReduxStore(),
    loadingActions,
    serverErrorActions,
    authActions,
    fetchRefreshToken,
    settings.redirectUri,
    settings.logoutUri
  );
  setAxiosConfigured(true);
};

// const NAVIGATION: Navigation = [
//   {
//     kind: "header",
//     title: "Main items",
//   },
//   {
//     title: "Dashboard",
//     icon: <DashboardIcon />,
//   },
//   {
//     segment: "orders",
//     title: "Orders",
//     icon: <ShoppingCartIcon />,
//   },
// ];

const BRANDING = {
  title: "Colegio Profesional de Fonoaudiólogos de La Pampa",
};

export default function App() {
  const [settings, setSettings] = useState<any>({});

  // Initializing settings from assets configuration
  useEffect(() => {
    if (!Object.keys(settings).length) {
      Promise.resolve(environment).then((data) => {
        setSettings(data);
      });
    }
  }, [settings]);

  // if (!Object.keys(settings).length) {
  //   Promise.resolve(environment).then((data) => {
  //     setSettings(data);
  //   });
  // }

  const authInfo = useSelector<RootState, UserInfo>(
    ({ auth }: any) => auth.info,
    // let info = auth.info; //, userName: auth.info.userIdentifier };
    // console.log("info", info);
    // // if (auth?.info)
    // //   if (auth.info?.userIdentifier) info.userName = auth.info.userIdentifier;
    // return info;
    shallowEqual
  );

  const [axiosConfigured, setAxiosConfigured] = useState(false);
  const [navigation, setNavigation] = useState<Navigation>([]);
  const [session, setSession] = React.useState<Session | null>();
  const [menuItems, setMenuItems] = useState<MenuItemModel[]>([]);

  useEffect(() => {
    if (!axiosConfigured) setupAxiosAsync(setAxiosConfigured);
    if (authInfo) {
      if (authInfo.role === "PROFESIONAL") {
        setMenuItems([
          { path: "/practicas", name: "Consultar", hasSubRoutes: true },
          {
            path: "/practicas/precarga-sempre",
            name: "Precarga SEMPRE",
            hasSubRoutes: true,
          },
          {
            path: "/practicas/informes",
            name: "Informes Mensuales",
            hasSubRoutes: true,
          },
          { path: "/convenios", name: "Convenios", hasSubRoutes: true },
          { path: "/perfil", name: "Mi Perfil", hasSubRoutes: false },
        ]);
        setNavigation([
          {
            kind: "header",
            title: "Menu",
          },
          {
            title: "Inicio",
            icon: <DashboardIcon />,
          },
          {
            segment: "practicas",
            title: "Prácticas",
            icon: <AssignmentOutlinedIcon />,
            children: [
              { segment: "list", title: "Consultar" },
              { segment: "precarga-sempre", title: "Precarga SEMPRE" },
              { segment: "informes", title: "Informes Mensuales" },
            ],
          },
          {
            segment: "convenios",
            title: "Convenios",
            icon: <HandshakeOutlinedIcon />,
          },
          {
            segment: "perfil",
            title: "Mi Perfil",
            icon: <ManageAccountsOutlinedIcon />,
          },
        ]);
      } else {
        setMenuItems([
          { path: "/practicas", name: "Consultar", hasSubRoutes: true },
          {
            path: "/practicas/informes",
            name: "Informes Mensuales",
            hasSubRoutes: true,
          },
          {
            path: "/practicas/enviar",
            name: "Envío de Prácticas",
            hasSubRoutes: true,
          },
          {
            path: "/practicas/remito-admin",
            name: "Remitos por OS",
            hasSubRoutes: true,
          },
          { path: "/sempre", name: "Importación", hasSubRoutes: true },
          { path: "/sempre/precarga", name: "Precarga", hasSubRoutes: true },
          {
            path: "/sempre/importacion",
            name: "Importación",
            hasSubRoutes: true,
          },
          { path: "/sempre/informes", name: "Informes", hasSubRoutes: true },
          { path: "/convenios", name: "Convenios", hasSubRoutes: true },
        ]);
        setNavigation([
          {
            kind: "header",
            title: "Menu",
          },
          {
            title: "Inicio",
            icon: <DashboardIcon />,
          },
          {
            segment: "practicas",
            title: "Prácticas",
            icon: <AssignmentOutlinedIcon />,
            children: [
              { segment: "list", title: "Consultar" },
              { segment: "informes", title: "Informes Mensuales" },
              { segment: "enviar", title: "Envío de Prácticas" },
              { segment: "remito-admin", title: "Remitos por OS" },
            ],
          },
          {
            segment: "sempre",
            title: "SEMPRE",
            icon: <BusinessOutlinedIcon />,
            children: [
              { segment: "precarga", title: "Precarga" },
              { segment: "importacion", title: "Importación" },
              { segment: "informes", title: "Informes" },
            ],
          },
          {
            segment: "convenios",
            title: "Convenios",
            icon: <HandshakeOutlinedIcon />,
          },
          // {
          //   segment: "usuarios",
          //   title: "Usuarios",
          //   icon: <GroupOutlinedIcon />,
          // },
        ]);
      }
    }

    // if (authInfo)
    //   setSession({
    //     user: {
    //       name: authInfo.firstName + authInfo.lastName,
    //       email: authInfo.userName,
    //     },
    //   });
  }, [axiosConfigured, authInfo]);

  const isLoading: boolean = useSelector<RootState, boolean>(
    ({ loading }) => loading.isLoading,
    shallowEqual
  );

  const serverError: ServerErrorState = useSelector<
    RootState,
    ServerErrorState
  >(({ serverError }) => serverError, shallowEqual);

  // const [session, setSession] = React.useState<Session | null>();
  //   {
  //   user: {
  //     name: "Bharat Kashyap",
  //     email: "bharatkashyap@outlook.com",
  //     // image: "https://avatars.githubusercontent.com/u/19550456",
  //   },
  // }
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const signOut = () => {
    dispatch(
      fetchLogout({
        redirectUri: settings.redirectUri,
        urlLogout: settings.logoutUri,
      })
    );
  };
  const authentication = React.useMemo(() => {
    return {
      signIn: () => {
        navigate("./sign-in");
        // setSession({
        //   user: {
        //     name: 'Bharat Kashyap',
        //     email: 'bharatkashyap@outlook.com',
        //     image: 'https://avatars.githubusercontent.com/u/19550456',
        //   },
        // });
      },
      signOut: () => {
        setSession(null);
        dispatch(
          fetchLogout({
            redirectUri: settings.redirectUri,
            urlLogout: settings.logoutUri,
          })
        );
      },
    };
  }, []);

  const loginTheme = useTheme();
  const theme = createTheme({
    cssVariables: {
      colorSchemeSelector: "data-toolpad-color-scheme",
    },
    colorSchemes: { light: true },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 600,
        lg: 1250,
        xl: 1536,
      },
    },
  });

  if (!authInfo) {
    // Sin sesión en la raíz → redirigir al portal público
    if (window.location.pathname === "/" || window.location.pathname === "") {
      window.location.replace("/portal/inicio");
      return null;
    }
    return (
      <AppProvider theme={loginTheme}>
        <CredentialsSignInPage></CredentialsSignInPage>
      </AppProvider>
    );
  }

  if (!axiosConfigured)
    return (
      <AppProvider theme={loginTheme}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            gap: "16px",
            color: "#64748b",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              border: "3px solid #e2e8f0",
              borderTopColor: "#06b6d4",
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
            }}
          />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <span style={{ fontSize: "0.95rem" }}>Iniciando aplicación...</span>
        </div>
      </AppProvider>
    );

  if (navigation) {
    return (
      <QueryParamProvider
        adapter={ReactRouter6Adapter}
        options={{ enableBatching: true }}
      >
        <AppProvider
          // session={session}
          // authentication={authentication}
          // navigation={undefined} //cambio menu: para volver reemplazar por la linea de abajo
          navigation={navigation}
          branding={BRANDING}
          theme={theme}
        >
          <div className="user-information">
            <div className="information">
              {authInfo.firstName +
                " " +
                authInfo.lastName +
                " | " +
                authInfo.role.toUpperCase()}
            </div>
            <Button
              size="small"
              startIcon={<LogoutOutlinedIcon />}
              onClick={signOut}
            >
              Salir
            </Button>
          </div>
          {/* <MenuList items={menuItems} /> */}
          <Routes>
            <Route path="/" element={<Layout />}>
              {AppRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Route>
          </Routes>
          <Outlet />
        </AppProvider>
      </QueryParamProvider>
    );
  } else
    return (
      <AppProvider>
        <Outlet />
      </AppProvider>
    );
}
